
const ventureStates = {
    "1": "Aktywne",
    "0": "Nieaktywne",
};

export default ventureStates;